export default "__VITE_ASSET__C_XTAQ_W__"